module.exports = __webpack_public_path__ + "static/Ankita-Abinesh-Ashwin-Tanmai-d565cbf0f190cbd16928a6a84f1776f5.png";